module.exports = __webpack_public_path__ + "img/cvf.659b5e18.webp";